let bundleLoadTimeStart: number = 0;

export function getBundleLoadTimeStart(): number {
    return bundleLoadTimeStart;
}

// Measure the time from the opening of the FlexPane to the start of the Time Panel load
export function onBundleLoadTimeStart(startTime: number): void {
    bundleLoadTimeStart = startTime;
}

export function clearBundleLoadTimeStart(): void {
    bundleLoadTimeStart = 0;
}
